import type { ReactNode, Ref } from 'react';
import { FormBuilder } from './FormBuilder';
import { Skeleton } from '../ui/Skeleton';

/** Shared editor canvas, including its pre-data state and footer destination. */
interface QuestionEditorSurfaceProps {
  children?: ReactNode;
  footer?: ReactNode;
  scrollRef?: Ref<HTMLDivElement>;
  busy?: boolean;
}

/** Pending fields are inert and cannot produce an authoring change. */
const ignorePendingChange = () => {};

/** Keep editor spacing owned by the same component before and after loading. */
export function QuestionEditorSurface({ children, footer, scrollRef, busy = false }: QuestionEditorSurfaceProps) {
  const loading = children === undefined;
  return (
    <div ref={scrollRef} className="flex flex-col h-full p-8 sm:px-16 overflow-y-auto scrollbar-dark"
      role={loading ? 'status' : undefined} aria-label={loading ? 'Loading questions' : undefined} aria-busy={loading || undefined}>
      <div inert={busy || loading} className="max-w-3xl w-full mx-auto space-y-6 pb-10">
        {children ?? <>
          <div aria-hidden="true" className="px-2 py-1 -ml-2 text-3xl font-bold tracking-tight"><Skeleton inline width="55%" /></div>
          <div aria-hidden="true" />
          <FormBuilder fields={[]} onChange={ignorePendingChange} isGenerating />
        </>}
      </div>
      {footer}
    </div>
  );
}
